<!--
 * @Description:修改密码模块
 * @Autor: txp
 * @Date: 2021-03-29 10:01:35
-->
<template>
  <div class="changepass">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">修改密码</span>
      </div>
      <div class="text item changepass_content pd2030">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="当前密码" prop="oldPassword">
                <el-input size="small" type="password" v-model="ruleForm.oldPassword" placeholder="请输入原密码" clearable></el-input>
              </el-form-item>
              <el-form-item label="更改密码" prop="pass">
                <el-input size="small" type="password" v-model="ruleForm.newPassword" placeholder="请输入新密码" clearable></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="checkPass">
                <el-input size="small" type="password" v-model="ruleForm.checkPass" placeholder="请再次输入新密码"></el-input>
              </el-form-item>
              <el-form-item class="textcenter">
                <el-button size="small" type="primary" @click="submitFrom">确定</el-button>
              </el-form-item>
            </el-form>
        </div>
    </el-card>
  </div>
</template>
<script>
/**
 * @description:  修改密码 ，在自定义验证规则，如果有其他的验证的方式，可封装到utils文件中引入使用
 * @param {*} ChangePassword 修改密码接口
 * @author: txp
 */
import {ChangePassword} from '@/api/api'
import {Storage} from "@/utils/storage"
export default {
  name: "favorites",
  data() {
    var oldPassword = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('密码不能为空'));
        }else{
          // if(value != Storage.l.get('password')){
          //    callback(new Error('密码输入错误'));
          // }else{
          //   callback();
          // }
          callback()
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
     ruleForm: {
          oldPassword: '',
          newPassword: '',
          checkPass: ''
        },
        rules: {
          oldPassword: [
            { validator: oldPassword, trigger: 'blur'}
          ],
          newPassword: [
            { validator: validatePass, trigger: 'blur'}
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur'}
          ]
        }
    };
  },
  methods: {
    submitFrom(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
           ChangePassword({
             newPassword:this.ruleForm.newPassword,
             oldPassword:this.ruleForm.oldPassword,
             userName: Storage.l.get('userName')
           }).then(res=>{
             if(res.code == 200){
                // Storage.l.set('password',this.ruleForm.newPassword)
               this.$message.success('修改密码成功')
             }
           }).catch(error=>{
             this.$message.error(error)
           })
        } else {
          return false;
        }
      });
    }
  },
};
</script>
<style lang="scss">
    .changepass{
      height: 100%;
      .el-card{
        height: 100%;
      .el-card__header {
        border-bottom: 0;
        padding: 20px 20px 0px 20px;
      }
      .clearfix {
          font-size: 16px;
      }
      .changepass_content{
          width: 440px;
          margin: 10% auto 0px;
          padding: 10px ;
          .el-card__header {
          border-bottom: 0;
          padding: 20px 20px 0px 20px;
          }
          .el-input{
              width: 350px;
          }
          .el-input__inner{
              border-radius: 2px;
              background: #F5F5F5;
          }
          .changepasstitle{
              font-size: 14px;
              color: #787878;
              letter-spacing: 0;
              margin-right: 20px;
          }
          .el-button{
              width: 120px;
          }
      }
      }
      
    }
</style>
